import Api from "./index";
import { endPoints, requestType } from "../constants/Variables";

export const fetchAllSales = (params) => {
  return Api(endPoints.fetchAllSales, params, requestType.POST);
};
